import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxPayee from '../util/remote/ajaxPayee';

const initialState = { 
    vendorListing: null,
    VendorCount: '...',
    metaData: null,
    currentPage: 1,
    mounted: false,
    payeeSearchList: null,
    searchHint: '',
    selectedVendor: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
    }
};


const VendorContext = createContext();

export const VendorProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

   useEffect(()=>{
      if(state.mounted){
        getVendorListing(false, true);
      }
    }, [state.currentPage])

    useEffect(()=>{
      if(state.searchHint?.length > 0){ 
        getVendorSearch();
      }
    }, [state.searchHint])


  const getVendorCount = async () => {
    const server_response  = await ajaxPayee.fetchVendorCount();
    if(server_response.status === "OK"){
        dispatch({ type: 'VendorCount', payload: server_response.details.total_p });
    }
  };

  const getVendorListing = async (refresh=false, nextPage=false) => {

    dispatch({ type: "mounted", payload: true });

    if(!refresh && Array.isArray(state.vendorListing) && !nextPage){
      return
    }

      dispatch({ type: 'vendorListing', payload: null });
      const server_response  = await ajaxPayee.listPayees({page: refresh? 1:  state.currentPage});
      if(server_response.status === "OK"){
          dispatch({ type: 'vendorListing', payload: server_response.details.data });
          dispatch({ type: 'metaData', payload: server_response.details.meta });
      }else{
        dispatch({ type: 'vendorListing', payload: "404" });
        dispatch({ type: 'metaData', payload: "404" });
      }
  };


  const getVendorSearch = async()=>{
    const server_response = await ajaxPayee.fetchVendorSearch(state.searchHint);
    if(server_response.status === "OK"){
      dispatch({ type: 'payeeSearchList', payload: server_response.details });
    }else{
      dispatch({ type: 'payeeSearchList', payload: "404" });
    }
  }

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const setSearchHint = (searchText)=>{
    dispatch({ type: 'searchHint', payload: searchText });
  }

  const setSelectedVendor = (vendor)=>{
    dispatch({ type: 'selectedVendor', payload: vendor });
  }

  return(
    <VendorContext.Provider value={{
      ...state, 
      dispatch, 
      getVendorCount,
      getVendorListing,
      setCurrentPage,
      setSearchHint,
      setSelectedVendor
      }}>
      {children}
    </VendorContext.Provider>
  )

}

export const useVendor = ()=>useContext(VendorContext);

